import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import 'normalize.css';
import './style.css';

ReactDOM.render(<App />, document.getElementById('root'));
